<template lang="">
  <div>
    <b-table
      ref="tableRef"
      show-empty
      :items="dados"
      :fields="headTable"
      sticky-header
    >
      <template #cell(dataHoraLogin)="data">
        <div>
          <span style="white-space:nowrap;">{{ data.item.dataHoraLogin ? maskDateHour(data.item.dataHoraLogin) : '' }}</span>
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>

import utils from '@/helpers/utils'

export default {
  name: 'LoginModal',
  props: {
    dados: {
      type: undefined,
      required: true,
    },
    relatorio: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { relatorio } = props
    const tableHeadUnidade = [
      { key: 'dataHoraLogin', label: 'Data Hora Login' },
      { key: 'ip', label: 'IP' },
    ]
    const tableHeadCliente = [
      { key: 'dataHoraLogin', label: 'Data Hora Login', thStyle: { whiteSpace: 'nowrap' } },
      { key: 'localEntrada', label: 'Local Entrada', thStyle: { whiteSpace: 'nowrap' } },
      { key: 'emailUnidade', label: 'Usuário', tdStyle: { whiteSpace: 'nowrap' } },
      { key: 'ip', label: 'IP' },
    ]

    const headTable = relatorio === 'UNIDADE' ? tableHeadUnidade : tableHeadCliente

    return {
      headTable,
      ...utils,
    }
  },
}
</script>
<style lang="">
  
</style>